export default "__VITE_ASSET__B_Yrm5kg__"